import SearchDataGrid from 'components/search/search-data-grid/search-data-grid.component';
import { useTranslation } from 'react-i18next';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  ACHTransactionType,
  AuditEvent,
} from 'api/giftcard-ach-service/giftcard-ach-service.types';
import { GridActionsCellItem, GridColDef } from '@mui/x-data-grid-premium';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import MoneyMovementsTransactionsEventsDrawer from './money-movement-transactions-events-drawer/money-movement-transactions-events-drawer.component';
import { parseISODateToLocaleString } from 'util/luxon-utils';
import TransactionsDataGridStatusChip from './transactions-data-grid-status-chip/transactions-data-grid-status-chip.component';
import { Typography } from '@mui/material';
import { formatCurrency } from 'util/currency';

const MoneyMovementTransactionsDataGrid = () => {
  const { t } = useTranslation();
  const { open, toggleWithData, drawerData, close } = useUtilityDrawer<{
    events: AuditEvent[];
    id: string;
  }>();
  const handleViewEventsClick = (row: ACHTransactionType) => {
    toggleWithData({ events: row.auditEvents, id: row.id });
  };

  const columns: GridColDef[] = [
    {
      field: 'sourceLocationName',
      headerName: t(
        'page.giftCards.moneyMovement.sections.transactions.dataGrid.columns.from',
      ),
      minWidth: 130,
      flex: 1,
      sortable: false,
      hideable: false,
    },
    {
      field: 'destinationLocationName',
      headerName: t(
        'page.giftCards.moneyMovement.sections.transactions.dataGrid.columns.to',
      ),
      minWidth: 130,
      flex: 1,
      sortable: false,
      hideable: false,
    },
    {
      field: 'amountFormatted',
      headerName: t(
        'page.giftCards.moneyMovement.sections.transactions.dataGrid.columns.amount',
      ),
      sortable: false,
      display: 'flex',
      renderCell: params => (
        <Typography>{formatCurrency(params.value)}</Typography>
      ),
    },
    {
      field: 'transferStartDate',
      headerName: t(
        'page.giftCards.moneyMovement.sections.transactions.dataGrid.columns.initiateDate',
      ),
      minWidth: 200,
      valueFormatter: value => parseISODateToLocaleString(value),
      sortable: false,
      flex: 1,
    },
    {
      field: 'transferEndDate',
      headerName: t(
        'page.giftCards.moneyMovement.sections.transactions.dataGrid.columns.completionDate',
      ),
      minWidth: 200,
      valueFormatter: value => parseISODateToLocaleString(value),
      sortable: false,
      flex: 1,
    },
    {
      field: 'status',
      headerName: t(
        'page.giftCards.moneyMovement.sections.transactions.dataGrid.columns.status',
      ),
      minWidth: 200,
      flex: 1,
      sortable: false,
      display: 'flex',
      renderCell: params => (
        <TransactionsDataGridStatusChip status={params.value} />
      ),
    },
    {
      field: 'actions',
      type: 'actions',
      getActions: params => [
        <GridActionsCellItem
          icon={<VisibilityOutlinedIcon />}
          label={t(
            'page.giftCards.moneyMovement.sections.transactions.dataGrid.columns.actions.viewEvents',
          )}
          showInMenu
          onClick={() => handleViewEventsClick(params.row)}
        />,
      ],
    },
  ];

  return (
    <>
      <SearchDataGrid
        columns={columns}
        onRowClick={params => handleViewEventsClick(params.row)}
      />
      <MoneyMovementsTransactionsEventsDrawer
        open={open}
        close={close}
        drawerData={drawerData}
      />
    </>
  );
};

export default MoneyMovementTransactionsDataGrid;
